import ApiClient from '@/ApiClient';
import { queryOptions, useQueryClient } from '@tanstack/vue-query';

export const getRecognitionLedger = () => {
  return queryOptions({
    queryKey: ['recognition_ledger'],
    queryFn: async () => {
      return await ApiClient.getRecognitionLedger();
    },
  });
};

export const getRecognitionInvoices = () => {
  return queryOptions({
    queryKey: ['recognition_invoices'],
    queryFn: async () => {
      const result = await ApiClient.getRecognitionInvoices();
      return result.data;
    },
  });
};

export const createRecognitionInvoice = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async payload => {
      return await ApiClient.createRecognitionInvoice(payload);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['recognition_invoices'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_ledger'] });
    },
  };
};

export const deleteRecognitionInvoice = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async invoiceId => {
      return await ApiClient.deleteRecognitionInvoice(invoiceId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['recognition_invoices'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_ledger'] });
    },
  };
};
